import React, { useState } from "react"
import { PhoneOutlined } from "@ant-design/icons"
import { Button, Col, Row, Typography } from "antd"
import { graphql, useStaticQuery } from "gatsby"
import WRPSearch from "../WRPSearch/WRPSearch"
import ButtonModal from "../ButtonModal/ButtonModal"
import OptInModal from "../Forms/OptInModal"
import { prettifyPhoneNumber } from "../../utils/phoneNumbers"
import style from "./BookingBar.module.scss"
import { MediaContext } from "@avldev/gatsby-theme-core-ui/context"

const checkAvailRowProps = {
  align: `middle`,
  className: style.checkAvailRow,
  justify: `center`,
  type: `flex`,
}

const emailCallRowProps = {
  align: "middle",
  className: style.emailCallRow,
  // justify: "space-around",
  justify: `center`,
  type: "flex",
}

const checkAvailColProps = {
  className: style.checkAvailCol,
  xs: 22,
  md: 20,
  lg: 18,
  xl: 16,
}

const getOffersColProps = {
  className: style.emailCol,
  xs: 11,
  sm: 10,
  md: 9,
  lg: 8,
  xl: 6,
}

const callTodayColProps = {
  className: style.callCol,
  xs: 11,
  sm: 10,
  md: 9,
  lg: 8,
  xl: 6,
}

const checkAvailTitleProps = {
  className: style.checkAvailTitle,
  level: 2,
}

export default props => {
  const data = useStaticQuery(graphql`
    query {
      contact: contentfulHotel(name: { eq: "Residences at Biltmore" }) {
        phone
      }
      modalImg: contentfulAsset(title: { eq: "Biltmore - Front - Autumn" }) {
        description
        fluid(maxWidth: 520) {
          ...fluid_withWebp_tracedSVG
        }
      }
    }
  `)

  const { width } = React.useContext(MediaContext)

  const { contact, modalImg } = data
  const phone = prettifyPhoneNumber(contact.phone)

  const [vis, setVis] = useState(false)

  const showCTAButtons = props.showCTAButtons === false ? false : true

  return (
    <div id="booking-bar">
      {/* Booking Engine Form */}
      <Row {...checkAvailRowProps} style={props.style || {}}>
        <Col {...checkAvailColProps}>
          <Typography.Title {...checkAvailTitleProps}>
            Book Your Suite Today
          </Typography.Title>
          <WRPSearch hotelID={process.env.WRP_HOTEL_ID} phone={phone} />
        </Col>
      </Row>
      {/* CTA Buttons (unless showCTAButtons is explicitly set to false) */}
      {showCTAButtons ? (
        <Row {...emailCallRowProps}>
          {/* Email Offers */}
          <Col {...getOffersColProps}>
            <ButtonModal
              cta={width < 350 ? `Email Offers` : `Get Email Offers`}
              image={modalImg}
              title="Exclusive Email Savings"
              body={
                <>
                  <Typography.Paragraph strong>
                    Looking for exclusive savings and offers for The Residences
                    at Biltmore All-Suite Hotel?
                  </Typography.Paragraph>
                  <Typography.Paragraph>
                    Sign up below and have the latest updates, events, and
                    special offers delivered right to you inbox! Unsubscribe any
                    time by clicking the “Unsubscribe” button found in every
                    email we send you.
                  </Typography.Paragraph>
                  <OptInModal
                    automationId={39}
                    formName="Email Offers"
                    gtmClickId="get-email-offers-form"
                    cancelText="Nevermind"
                    submitText="Sign Up!"
                    toggleModal={() => {
                      setVis(!vis)
                    }}
                  />
                </>
              }
              hideButtons={true}
              visible={vis}
              toggleModal={() => {
                setVis(!vis)
              }}
            />
          </Col>
          {/* Call Today */}
          <Col {...callTodayColProps}>
            <Button size="large">
              <a className="click-to-call" href={`tel:${phone}`}>
                <span>
                  <PhoneOutlined style={{ marginRight: 4 }} />
                  {width < 350 ? `Call Now` : phone}
                </span>
              </a>
            </Button>
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </div>
  )
}
